import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 sm:px-6 bg-brand-taupe text-center text-brand-cream/60 text-[10px] sm:text-xs" data-id="element-72" data-mp="32wd2cf6gdjt0">
      <p className="leading-tight max-w-2xl mx-auto font-medium mb-3" data-id="element-73" data-mp="3ghc2o28413o8">
        © {new Date().getFullYear()} Dance Ready™ — All Rights Reserved. The
        content of this page is for informational and educational purposes only.
        It does not replace certified professional dance training or formal
        dance education qualifications. Always ensure safe teaching practices in
        your studio environment.
      </p>
      <div className="flex justify-center gap-2 sm:gap-3 font-bold tracking-wide uppercase" data-id="element-74" data-mp="3lem0o69kenno">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-75" data-mp="3qdf7jfucjgev">
          Terms & Conditions
        </a>
        <span data-id="element-76" data-mp="29yno3sf6hjhp">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-77" data-mp="29y5fdwbbxcsw">
          Privacy Policy
        </a>
        <span data-id="element-78" data-mp="2ez1k2c3i92zd">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79" data-mp="2ew700loelk6h">
          Contact
        </a>
      </div>
    </footer>;
}